/** The mobile action appears only after the in-page action has scrolled past. */
class BuyBar extends HTMLElement {
  #io;
  #headerObserver;
  #barObserver;

  connectedCallback() {
    const target = document.querySelector(this.dataset.watch || '');
    if (!target || !('IntersectionObserver' in window)) return;
    const header = document.querySelector('#header-group');
    const watch = () => {
      this.#io?.disconnect();
      const top = Math.ceil(header?.getBoundingClientRect().height || 64);
      this.#io = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > (entry.rootBounds?.top || top);
      }, { rootMargin: `-${top}px 0px 0px 0px` });
      this.#io.observe(target);
    };
    watch();
    if ('ResizeObserver' in window) {
      this.#headerObserver = new ResizeObserver(watch);
      if (header) this.#headerObserver.observe(header);
      this.#barObserver = new ResizeObserver(() => {
        if (!this.hidden) document.body.style.setProperty('--tt-buybar-height', `${this.getBoundingClientRect().height}px`);
      });
      this.#barObserver.observe(this);
    }
  }

  disconnectedCallback() {
    this.#io?.disconnect();
    this.#headerObserver?.disconnect();
    this.#barObserver?.disconnect();
    document.body.style.removeProperty('--tt-buybar-height');
  }
}

if (!customElements.get('tt-buybar')) {
  customElements.define('tt-buybar', BuyBar);
}
